module.exports = __webpack_public_path__ + "static/img/tzggTitle.e87bcad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tzggTitle.png
// module id = LXU7
// module chunks = 2